import { BsData } from "../../models/ExchBetSlip";
import SAP_API from "../../services/sap";
import store from "../store";
import { addExchangeBetHandler, clearExchangeBets, setOpenBets, setBettingInprogress } from "./exchBetSlipReducer";
import { getBetStatus, placeBet } from "../../utils/bettingUtils";
import { toast } from "react-toastify";


export const addExchangeBet = (data: BsData) => {
  return async (dispatch: Function) => {
    dispatch(clearExchangeBets({}));

    // Check if one-click betting is enabled and set stake amount
    const state = store.getState();
    const { isOneClickBettingEnabled, oneClickBettingStake } = state.exchBetSlip;

    if (isOneClickBettingEnabled && oneClickBettingStake > 0) {
      // Set the stake amount for one-click betting
      data.stakeAmount = oneClickBettingStake;

      // For one-click betting, automatically place the bet
      dispatch(addExchangeBetHandler(data));
      placeBet(data, dispatch, (betData: BsData) => getBetStatus(betData, dispatch));
    } else {
      // Normal betting flow - just add to betslip
      dispatch(addExchangeBetHandler(data));
    }
    //   dispatch(setOpenSlider(true))
  };
};


export const fetchOpenBets = (eventId: string, sportId: string) => {

  return async (dispatch: Function) => {
    let authData: any;
    if (store.getState().userDetails.lobby == "EXCHANGE") {
      authData = store.getState().userDetails.exchData;
    } else {
      authData = store.getState().userDetails.sbData;
    }
    let data = {
      token: authData?.token,
      operatorId: authData?.operatorId,
      sportId: sportId,
      eventId: eventId,
    };

    if (sportId && eventId) {
      try {
        let result = null;
        result = await SAP_API.post(`/core/getopenbets`, data);
        if (result && result?.data.status === "RS_OK") {
          dispatch(setOpenBets(result.data?.openBets));
        }
      } catch (err) {
        dispatch(setOpenBets([]));
      }
    }
  };
};

export const turboCashout = async (
  marketId: string,
  sportId: string,
  eventId: string,
  provider: string,
  dispatch: Function
) => {
  // Get token from exchData in store
  const state = store.getState();
  const authData = state.userDetails.exchData;

  const payload = {
    providerId: provider,
    sportId: sportId,
    eventId: eventId,
    marketId: marketId,
    token: authData?.token,
    reqTime: Date.now(),
  };

  dispatch(setBettingInprogress(true));

  try {
    const response = await SAP_API.post("/core/turbo-cashout", payload);

    if (response?.data?.status === "RS_OK" && response.data?.errorDescription === "") {
      // Start polling for cashout status
      return await getCashoutStatus(authData?.token, authData?.operatorId, sportId, eventId, dispatch);
    } else {
      dispatch(setBettingInprogress(false));
      toast.error(response.data?.errorDescription || 'Turbo cashout failed');
      return false;
    }
  } catch (error: any) {
    dispatch(setBettingInprogress(false));
    toast.error(error?.response?.data?.message || 'Turbo cashout failed');
    throw error; // Re-throw to be caught by the button handler
  }
};

export const getCashoutStatus = async (token: string, operatorId: string, sportId: string, eventId: string, dispatch: Function) => {
  dispatch(setBettingInprogress(true));
  const payload = {
    token: token,
    operatorId: operatorId,
  };

  const startTime = Date.now();
  const maxDuration = 60000; // 1 minute in milliseconds

  while (true) {
    try {
      // Check if we've exceeded the maximum duration
      if (Date.now() - startTime > maxDuration) {
        dispatch(setBettingInprogress(false));
        toast.error("timed out");
        return false;
      }

      const res: any = await SAP_API.post("/core/cashout-status", payload);

      if (["BETTING_IN_PROGRESS", "PENDING"].includes(res.data.betStatus)) {
        await new Promise(resolve => setTimeout(resolve, 500));
        continue;
      } else if (
        res.data.status === "RS_OK" &&
        ["CANCELLED", "EXPIRED", "FAILED"].includes(res.data.betStatus)
      ) {
        dispatch(setBettingInprogress(false));
        toast.error(
          res.data.betErrorMsg
            ? res.data.betErrorMsg
            : "Cashout failed, try again"
        );
        return false;
      } else if (res.data?.betStatus === "COMPLETED") {
        dispatch(setBettingInprogress(false));
        toast.success(
          res.data.errorDescription
            ? res.data.errorDescription
            : "Turbo cashout successful."
        );
        // setTimeout(() => {
        dispatch(fetchOpenBets(eventId, sportId));
        // }, 500);
        return true;
      }
    } catch (error: any) {
      dispatch(setBettingInprogress(false));
      toast.error("Something went wrong with cashout status, try again");
      return false;
    }
  }
};